import Box from '@mui/material/Box';
import React, { PropsWithChildren } from 'react';

export default function MainContent({ children }: PropsWithChildren<{}>) {
  return <Box sx={{ flex: 1 }}>{children}</Box>;
}
